import MainLayout from 'layouts/MainLayout';

import Start from '../pages/Start';
import Conversation from '../pages/Conversation';

const routes =  [{
    layout: MainLayout,
    routes: [{
        path: '/agents/mcm-rapportini/:agentId',
        element: Start,
        exact: true,
        analytics: { name: ["Agente", "MCM Rapportini"] },
    }, {
        path: '/agents/mcm-rapportini/:agentId/conversations/:conversationId',
        element: Conversation,
        exact: true,
        analytics: { name: ["Agente", "Conversazione"] },
    }]
}]

export default routes;
